import Axios from "axios";

const state = {
    cart: null
};

const getters = {
    cart: state => state.cart
};

const mutations = {
    setCart: (state, data) => state.cart = data
};

const actions = {
    getCart: async (context, data) => {
        let response = await Axios.post((<any>window).App.routes.Cart_GetDetail);

        if (response.data.coupon === null) {
            response.data.coupon = {};
        }

        context.commit("setCart", response.data);

        return response;
    },
    setCart: (context, data) => {
        context.commit("setCart", data);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};